var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 15H22.5V18.75H13.125V15ZM13.125 22.5H22.5V26.25H13.125V22.5ZM13.125 30H22.5V33.75H13.125V30ZM37.5 15H46.875V18.75H37.5V15ZM37.5 22.5H46.875V26.25H37.5V22.5ZM37.5 30H46.875V33.75H37.5V30Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 7.5H7.5C6.50574 7.50099 5.55249 7.8964 4.84945 8.59945C4.1464 9.30249 3.75099 10.2557 3.75 11.25V52.5C3.75099 53.4943 4.1464 54.4475 4.84945 55.1506C5.55249 55.8536 6.50574 56.249 7.5 56.25H52.5C53.4943 56.249 54.4475 55.8536 55.1506 55.1506C55.8536 54.4475 56.249 53.4943 56.25 52.5V11.25C56.249 10.2557 55.8536 9.30249 55.1506 8.59945C54.4475 7.8964 53.4943 7.50099 52.5 7.5ZM7.5 11.25H28.125V52.5H7.5V11.25ZM31.875 52.5V11.25H52.5V52.5H31.875Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSix);
export default __webpack_public_path__ + "static/media/icon_six.72ceaede5c484d267a036f23f7e30ff8.svg";
export { ForwardRef as ReactComponent };